import { Vendors } from '@porterin/component-library/src/ts-utils/analytics/constants/AnalyticsConstants';
import { CountryVendorConfig } from '@porterin/component-library/src/ts-utils/analytics/react-ga/types/AnalyticsConfigTypes';

export const countryVendorConfig = {
  uae: [Vendors.ga],
  bd: [Vendors.ga],
  tr: [Vendors.ga],
} as const satisfies CountryVendorConfig;
